<template>
  <b-card-code title="All Organizations">
        <button
      v-if="
        this.$store.state.app.user.permissions.includes(
          'organization.add_organization'
        )
      "
      @click="addOrg()"
      type="button"
      class="btn ml-auto btn-primary m-1"
    >
      Add New
    </button>
      <b-card-code class="bg-light-secondary mb-1" title="Search">
        <b-form inline style="display: inline-block; width: 100%;">
            <div class="row" style="width: 100%;padding:5px">
            <b-form-input
              class="ml-1"
              id="name_filter"
              v-model="name_filter"
              style="width: 60%"
              name="name_filter"
              placeholder="Search with Name"
            />
            <!-- <b-form-select
              class="ml-1"
              style="width: 25%"
              v-model="type_filter"
              :options="type_filter_options"
            >
            </b-form-select> -->
            <b-button
              style="width: 20%"
              class="ml-1"
              variant="primary"
              @click="load(true)"
            >
              Search
            </b-button>
          </div>
        </b-form>
      </b-card-code>


    <b-table
      responsive
      id="orgTable"
      :fields="fields"
      :items="items"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template #cell(actions)="data">
        <!-- <button @click="editOrg(data.item.org_id)" type="button" class="btn btn-primary btn-sm mr-1" style="position: relative;"> Edit</button>
        <button @click="deleteOrg(data.item.org_id)" type="button" class="btn btn-danger btn-sm mr-1" style="position: relative;"> Delete </button> -->
        <b-dropdown
          size="sm"
          class="ml-1"
          variant="outline-primary"
          text="Actions"
        >
          <b-dropdown-item @click="editOrg(data.item.org_id)"
            >Edit</b-dropdown-item
          >
          
          <!-- <b-dropdown-item @click="allocateScanners(data.item.org_id)">Default Scanners</b-dropdown-item> -->
          <b-dropdown-divider />
          <b-dropdown-item @click="deleteOrg(data.item.org_id)"
            >Delete</b-dropdown-item
          >
        </b-dropdown>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      :align="pagination_pos"
      aria-controls="orgTable"
    />

  </b-card-code>
</template>

<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { BFormInput, BTable } from "bootstrap-vue";
import {
  BPagination,
  BPaginationNav,
  BButton,
  BDropdown,
  BDropdownItem,
  BDropdownDivider,
  BForm
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCardCode,
    BTable,
    BPagination,
    BPaginationNav,
    BButton,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BForm,
    BFormInput
  },
  data() {
    return {
      pagination_pos: "center",
      // Call orgaization API and return in this format
      items: [],
      currentPage: 1,
      perPage: 10,
      rows: 0,
      id: 0,
      fields: [
        { key: "org_id", label: "#" },
        { key: "org_name", label: "Name" },
        { key: "added_by", label: "Added By" },
        { key: "added_from", label: "Added From" },
        // { key: "org_address", label: "Address" },
        { key: "actions", label: "Actions" },
      ],
      name_filter: '',
    };
  },
  created: function () {
    this.load();
  },
  methods: {
    load: function (search=false) {
      let url =process.env.VUE_APP_BASEURL + "organization/organization?query=true"
      if (this.name_filter){
        if(search)
          url = url+"&name="+this.name_filter
        // this.currentPage = 1
      }
        
      const options = {
        method: "GET",
        headers: { "content-type": "application/json" },
        url: url,
      };
      this.$http(options).then((res) => {
        console.log(res.data);
        // this.toastMessage(res)  // method call to method2
        this.items = res.data;
        this.rows = res.data.length;
        //   this.currentPage = 1
        //   this.perPage = 10
        //   this.rows = res.data.count
      });
    },
    addOrg() {
      this.$router.push({ name: "Add Organization" });
    },
    editOrg(id) {
      this.$router.push({ name: "Edit Organization", params: { id: id } });
    },

    deleteOrg(id) {
      if (confirm("Do you really want to delete?")) {
        const options = {
          method: "DELETE",
          headers: { "content-type": "application/json" },
          url:
            process.env.VUE_APP_BASEURL +
            "organization/organization/" +
            id +
            "/",
        };
        this.$http(options).then((res) => {
          console.log(res);
          this.load();
          //if(res.data.org_id){
          // this.$router.push({name: 'Organizations'});
          // }
        });
      }
    },

    closeModal() {
      this.$refs["report_generator"].hide();
    },
  },
};
</script>
